import { render, staticRenderFns } from "./supervise.vue?vue&type=template&id=a95a22be&scoped=true"
import script from "./supervise.vue?vue&type=script&lang=js"
export * from "./supervise.vue?vue&type=script&lang=js"
import style0 from "./supervise.vue?vue&type=style&index=0&id=a95a22be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95a22be",
  null
  
)

export default component.exports